import store from '../../../core/store';

export const listCurrentSetSpecificationSets = (stage_id) => {
  return store.dispatch({
    action:
      'table.current_set_specification_sets/LIST_CURRENT_SET_SPECIFICATION_SETS',
    method: 'GET',
    endpoint: '/stages/' + stage_id + '/specifications/current/sets',
    main: true,
  });
};
